import PropTypes from 'prop-types';
import React from 'react';
import Velocity from 'velocity-animate';

export default class Illustration extends React.Component {
  static propTypes = {
    type: PropTypes.string,
    variants: PropTypes.number,
    delayed: PropTypes.number,
    className: PropTypes.string,
  };

  static defaultProps = {
    delayed: 0,
    variants: 0,
  };

  /**
   * Binds all private methods
   * @param  {Object} props Component props
   */
  constructor(props) {
    super(props);

    this.state = {
      loading: true,
    };

    this.preloadImage = this.preloadImage.bind(this);
  }

  shouldComponentUpdate(nextProps) {
    // only update when image is updated/loaded
    return (
      this.state.loading ||
      this.props.variants !== nextProps.variants ||
      this.props.type !== nextProps.type
    );
  }

  componentDidMount() {
    if (this.props.delayed) {
      this.preloadImageTimeout = setTimeout(
        this.preloadImage,
        this.props.delayed
      );
    } else {
      this.preloadImage();
    }
  }

  componentWillUnmount() {
    clearTimeout(this.preloadImageTimeout);
  }

  static getRandomIllustration(random) {
    return Math.floor(Math.random() * random) + 1;
  }

  static preload(type, callback = false) {
    let node = type; // Because a node and a type can be the same "thing"
    let removeNode = false;

    // If it's a string we need to make a node for it
    if (typeof node === 'string') {
      removeNode = true;
      node = document.createElement('div');
      node.className = `illustration illustration__${type}`;
      document.body.appendChild(node);
    }

    // Get the background image url (without url())
    let image = Velocity.hook(node, 'background-image');
    if (!image) {
      return;
    }
    image = image.replace(/.*\s?url\(['"]?/, '').replace(/['"]?\).*/, '');

    // Cleanup our preloader node
    if (removeNode) {
      const parent = node.parentNode;
      if (parent) {
        parent.removeChild(node);
      }
      node = null;
    }

    // Now we'll try to load the image.
    let preload = new Image();
    preload.onerror = preload.onload = preload.onabort = () => {
      const parent = preload.parentNode;
      if (parent) {
        parent.removeChild(preload);
      }
      preload = null;
      if (callback) {
        callback();
      }
    };
    preload.src = image;
  }

  preloadImage() {
    if (!this.node) {
      return;
    }
    Illustration.preload(this.node, () => {
      // FIXME: this is an asynchronous callback.
      // Can be the case that this component is not unmounted at this point,
      // causing incorrect calls to setState
      this.setState({ loading: false });
    });
  }

  render() {
    // Render the illustration with a className.
    const { className, variants } = this.props;
    let { type } = this.props;

    if (type.indexOf(' ') !== -1) {
      return null;
    }

    if (variants > 1) {
      type += '-random-' + Illustration.getRandomIllustration(variants);
    }

    // Compose the className
    const classNames = [`illustration illustration__${type}`];
    if (className) {
      classNames.push(className);
    }

    // Are we still loading?
    if (this.state.loading) {
      classNames.push('illustration--loading');
    }

    // Render illustration as Span (because not always needed in block mode)
    return (
      <span
        ref={(node) => (this.node = node)}
        className={classNames.join(' ')}
      />
    );
  }
}
